import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PodValidationSearchCriteria} from '../shared/pod-validation-search-criteria.model';
import {PodState, PodValidation, TabResultCount} from '../shared/pod-validation.model';

@Component({
  selector: 'app-pods-validation-list',
  templateUrl: './pods-validation-list.component.html',
  styleUrls: ['./pods-validation-list.component.scss']
})
export class PodsValidationListComponent {

  @Input() public filters: PodValidationSearchCriteria;
  @Input() public tabResultCount: TabResultCount;
  @Input() public lastPage;
  @Input() public displayedPod: PodValidation;
  @Input() public podsValidation: PodValidation[];

  @Output() public podSelected: EventEmitter<PodValidation> = new EventEmitter<PodValidation>();
  @Output() public podRejected: EventEmitter<PodValidation> = new EventEmitter<PodValidation>();
  @Output() public podValidated: EventEmitter<PodValidation> = new EventEmitter<PodValidation>();
  @Output() public podUploaded: EventEmitter<PodValidation> = new EventEmitter<PodValidation>();
  @Output() public appendOriginGlidFilter: EventEmitter<string> = new EventEmitter<string>();
  @Output() public appendDestinationGlidFilter: EventEmitter<string> = new EventEmitter<string>();
  @Output() public filtersChange: EventEmitter<PodValidationSearchCriteria> = new EventEmitter<PodValidationSearchCriteria>();

  public pageSizeOptions = [5, 10, 20, 30, 40, 50];
  public POD_STATE = PodState;

  constructor(
) {}

  public selectPendingTab = () => this.onTabChange(PodState.PENDING)

  public selectReviewTab = () => this.onTabChange(PodState.CHEP_REVIEW)

  public selectValidationTab = () => this.onTabChange(PodState.VALIDATED);

  public getPodValidationId(index: Number, podValidation: PodValidation): string {
    return podValidation.loadNumber + podValidation.deliveryNumber;
  }

  public onTabChange(state: PodState): void {
    this.filters.podState = state;
    this.filters.page = 1;
    this.filters.pageSize = 10;
    this.filtersChange.emit(this.filters);
  }

  public onPageChange(page: number, size: number): void {
    this.filters.page = page;
    this.filters.pageSize = size;
    this.filtersChange.emit(this.filters);
  }
}
